import { IRootState } from '../../../../store'
import { INeuroState } from '../store/neuro.types'

export const getNeuroSelector = (state: IRootState): INeuroState => state.neuro
